// Display-only capitalization for admin/vendor free text (e.g. Product Color
// Variant names like "red" or "navy blue" imported from vendor feeds with
// inconsistent casing). Does not touch storage/matching — only the rendered
// label.
export function capitalizeLabel(value: string): string {
  return value.length === 0 ? value : value[0].toUpperCase() + value.slice(1);
}
